import { Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {TagsListService} from './tagsList.service';
import {TagItem} from '../tags.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {getVid, getBackendSystem} from '../../appConfig/appConfigForward';
import {TagsService} from '../tags.service';
import {UserSessionManagerService} from  '../../security/userSessionManager.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {LoginService} from '../../security/login/login.service';
import {PrimolyticsService,beacon} from '../../analytics/primolytics.service';
import {PreFiltersService} from "../../search/preFilters/preFilters.service";

const find= require('lodash/find');
var angular: angular.IAngularStatic = require('angular');

@Component({
    selector: 'prm-tags-list',
    templateUrl: 'components/tags/tagsList/tags-list.html',
})
 
export class PrmTagsList{
    @Input() item: PrimoResponse.IDoc;
    @Input() tagslist: Array<TagItem>;
    @Input() usertagslist: Array<TagItem>;
    @Input() editable:boolean;//true in full display and false in tags page 
    @Input() isFullDisplay:boolean;//true in full display and false in tags page 
    public editTagsMode:boolean;
    public validInputRegex = '^[0-9A-Za-z_\'-]+$';
    public invalidInputRestResponse = 'The request sent by the client was syntactically incorrect.';
    public searchText:string;
    public selectedItem:any;
    public isSearchTextValid:boolean;
    
    constructor(private userSessionManagerService:UserSessionManagerService,
                private tagsListService: TagsListService,
                private tagsService: TagsService,
                private loginService: LoginService,
                private primolyticsService:PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$mdDialog') private $mdDialog:angular.material.IDialogService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private preFiltersService: PreFiltersService) {
        this.editTagsMode = false;
        this.isSearchTextValid = true;

    }

    /*
    returns the advanced search url of tagName
    */
    public resultSearchUrl(tagName) {
        let searchMode = this.$stateParams['mode'];
        if (!this.preFiltersService.isPreFilterEnable(this.$stateParams['tab'])) {
            searchMode = 'advanced';
        }
            
        
        let query = 'usertag,contains,';
        if (getBackendSystem() === 'suprima') {
            query = 'user_tags,exact,'
        }
        query+=tagName;
        if (searchMode === 'advanced') {
            query+=',AND';
        }   
        
        let params = {
            query:query,
            vid:getVid()
        };
        
        if (searchMode) {
            params.mode = searchMode;
        }
           
        return JSON.stringify(params);
    }
    public closeDialog(){
        this.$mdDialog.hide();
    }
    
    /*
    returns the advanced search url of tagName
    */
    get autocompleteTagslist(){
        return this.tagsService.myTags;
    }
    
    /*
    to show All Non User Tags
    */
    get showAllNonUserTags(){
        return this.tagsService.showAllNonUserTags;
    }
    
    /*
    shows all the tags when there are more then non user 10 tags
    */
    public showAllRecordNonUserTags(){
        return this.tagsService.showAllRecordNonUserTags();
    }
    
    /*
    to enter edit tags mode
    */
    public editTags(){
        this.editTagsMode = true;
        this.addFocusToInput();
    }

    private addFocusToInput(){
        // Give focus to the add tags input field.
        this.$timeout(() => {
            let elem = document.querySelector('#own-tags-input') as HTMLElement;
            if (elem) {
                elem.focus();
            }
        }, 0);
    }
    
    /*
    returns true if user Logged In
    */
    public userLoggedIn(){
        return this.userSessionManagerService.getUserName().length > 0;
    }
    
    /*
    runs on Tag Add
    */
    @beacon({'p':'tags','op':'deleteTag'})
    public onTagRemove(chip){
        this.tagsService.removeTag(this.item,chip.tagName); 
    }
    
    /*
    called after clicking 'add your own tag button'
    */
    public handleLoginClick(){
        this.loginService.handleLoginClick();
        this.loginService.sendAnalytics('manually');
    }
    
    /*
    adds the tag to the DB and to the UI
    */
    public addTag(tagName){
        if(tagName.tagName) {//autocomplete returns a tag object
            tagName = tagName.tagName;
        }
        let promise = this.tagsService.addTag(this.item,tagName);
        promise.then(
            (response) => this.onSuccess(), 
            (response) => this.onError(response.data)); 
    }
    
    /*
    validates input on search Text Change
    */
    public searchTextChange(){
        if(this.searchText.length > 0 && !this.isValidInput(this.searchText)){
            this.isSearchTextValid = false;
        }
        else{
            this.isSearchTextValid = true;
        }
    }
    
    /*
    validates input
    */
    public isValidInput(tagName){
        return (   !(find(this.usertagslist, { 'tagName': tagName }))
                &&  !(find(this.tagslist, { 'tagName': tagName })) 
                &&  (tagName.length < 36) 
                &&  (tagName.length > 0) 
                &&  (tagName.match(this.validInputRegex)) );
    }
    
     /*
     * returns the filtered autocomplete list
     */
    public querySearch (query) {
      let results = query ? this.tagsService.myTags.filter(this.createFilterFor(this.searchText)) : this.tagsService.myTags;
      return results;
    }

    /**
     * Create filter function for a query string
     */
    public createFilterFor(query) {
      if (query) {
      	let lowercaseQuery = query.toLowerCase();

      	return function filterFn(tagItem) {
        	return (tagItem.tagName.indexOf(lowercaseQuery) === 0);
      	};
      }
      else {
      	return function filterFn(tagItem) {
	        return true;
	      };
      }

    }

    /*
    on add tags success
    */
    @beacon({'p':'tags', 'op': 'addTags'})
    public onSuccess(){
        this.tagsService.getRecordTagsFromApi(this.item.pnx.control.recordid);
        this.isSearchTextValid = true;
        return null;
    }
    
    /*
    on add tags success
    */
    public onError(responseData){
        this.tagsService.getRecordTagsFromApi(this.item.pnx.control.recordid);
        if(responseData.indexOf(this.invalidInputRestResponse) !== -1){
            this.isSearchTextValid = false;
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsList/tagsList.directive.ts